document.querySelector('.js-toggle-navigation').addEventListener('click', (e) => {
    e.currentTarget.querySelector('.hamburger').classList.toggle('is-active');
    document.querySelector('.content__menu').classList.toggle('is-visible');
    document.querySelector('.content__nav-toggle').classList.toggle('is-toggled');
    document.querySelector('html').classList.toggle('no-scroll');
    document.querySelector('body').classList.toggle('no-scroll');
});

document.querySelectorAll('li.menu-item-has-children > a').forEach(item =>
    item.addEventListener('click', (e) => {
        if (window.innerWidth < 1200) {
            e.preventDefault();
            e.currentTarget.closest('li.menu-item-has-children').classList.toggle('is-toggled');
            e.currentTarget.closest('li.menu-item-has-children').querySelector('.sub-menu').classList.toggle('is-visible');
        }
    })
)

document.querySelectorAll('li.menu-item-has-children').forEach(item =>
    item.addEventListener('mouseenter', (e) => {
        if (window.innerWidth > 1199) {
            e.preventDefault();
            e.currentTarget.closest('li.menu-item-has-children').classList.add('is-toggled');
            e.currentTarget.closest('li.menu-item-has-children').querySelector('.sub-menu').classList.add('is-visible');
        }
    })
)

document.querySelectorAll('li.menu-item-has-children').forEach(item =>
    item.addEventListener('mouseleave', (e) => {
        if (window.innerWidth > 1199) {
            e.preventDefault();
            e.currentTarget.closest('li.menu-item-has-children').classList.remove('is-toggled');
            e.currentTarget.closest('li.menu-item-has-children').querySelector('.sub-menu').classList.remove('is-visible');
        }
    })
)

document.addEventListener('click', function(e) {
    const subMenu = document.querySelector('.sub-menu.is-visible');
    const contentMenu = document.querySelector('.content__menu.is-visible');

    if (subMenu) {
        if (!e.target.closest('.menu-item-has-children.is-toggled')) {
            subMenu.closest('.is-toggled').classList.remove('is-toggled');
            subMenu.classList.remove('is-visible');
        }
    }

    if (contentMenu) {
        if (!e.target.closest('.content__menu') && !e.target.closest('.js-toggle-navigation')) {
            document.querySelector('.hamburger').classList.remove('is-active');
            document.querySelector('.content__menu').classList.remove('is-visible');
            document.querySelector('.content__nav-toggle').classList.remove('is-toggled');
            document.querySelector('html').classList.remove('no-scroll');
            document.querySelector('body').classList.remove('no-scroll');
        }
    }
});

